module.exports = __webpack_public_path__ + "static/media/star-half.529ab3e2.svg";